import * as React from 'react';
import { connect } from 'react-redux';
import { DetailsActions } from '../../../../actions/details.actions';
import { connectNLP } from '../../../../utilities/connect-navigate';
import { isInQuery } from '../../../../utilities/helper-fuctions';
import { ContributeButton } from '../../../other/contribute-button';
import { StatusMarker } from '../../../ui-components/statusmarker/status-marker';
import { Widget } from '../../widget';
import {
	getAirportRefuelEuByAirportAid,
	getRefuelEuColor,
	getRefuelEuDate,
	getRefuelEuStatus,
} from './refuel-eu-helpers';
import './refuel-eu.scss';

const mapStateProps = (store: any) => ({
	date: store.userDetails.date || 'yyyy. MM. dd. HH:mm',
});

const mapDispatchProps = (dispatch: any) => ({
	setSuccess: () => dispatch(DetailsActions.setSuccess(false)),
});

class RefuelEuComponent extends Widget<any, any> {
	public async fetch() {
		const airportAid = this.props?.airport?.aid;

		if (!airportAid) {
			return;
		}

		try {
			this.setStates({ loading: true, error: false });
			const response = await getAirportRefuelEuByAirportAid(airportAid);
			this.setStates({
				response,
				render: !response,
				error: false,
			});
		} catch (err: any) {
			if (err?.response?.status === 404) {
				this.setStates({ error: false, response: false, render: true });
				return;
			}

			this.setStates({
				error: err?.response?.data?.message || err || 'Error',
				response: false,
				render: false,
			});
		} finally {
			this.setStates({ loading: false });
		}
	}

	public renderContent(): React.ReactElement {
		const data = this.state?.response;

		if (!data) {
			return (
				<div className='w-100 display-flex justify-content-center py-6'>
					<ContributeButton
						openModal={() => this.openModal()}
						buttonOnly={true}
					/>
				</div>
			);
		}

		const status = getRefuelEuStatus(data?.isEligible);
		const dateFormat = this.props?.date || 'yyyy. MM. dd. HH:mm';
		const isEligible = data?.isEligible === 'YES';
		const validFrom = getRefuelEuDate(data?.validFrom, dateFormat);
		const validTo = getRefuelEuDate(data?.validTo, dateFormat);

		return (
			<div className='RefuelEuWidget w-100'>
				<div className='RefuelEuCard border-1 palette--bc-neutral-3 border-radius-1 overflow-hidden'>
					<div className='RefuelEuRow row mx-0 px-3 py-3'>
						<p className='col-24 col-md-8 palette--c-neutral-5 m-0'>
							REFUELEU eligible
						</p>
						<div className='col-24 col-md-16 p-0 mt-2 mt-md-0'>
							<div className='display-flex align-items-center flex-wrap'>
								<StatusMarker
									tColor='neutral-1'
									bgColor={getRefuelEuColor(data?.isEligible)}
									text={status}
									type='tag'
									classNames='mb-2 mr-2'
								/>
								{data?.aid && (
									<StatusMarker
										tColor='secondary-4'
										bgColor='secondary-1'
										text={data?.aid}
										type='badge'
										classNames='mb-2'
									/>
								)}
							</div>
						</div>
					</div>
					{isEligible && (
						<>
							<div className='RefuelEuRow row mx-0 px-3 py-2 border-top-1 palette--bc-neutral-3'>
								<p className='col-24 col-md-8 palette--c-neutral-5 m-0'>
									Valid from
								</p>
								<p className='col-24 col-md-16 palette--c-neutral-6 fw-bold m-0'>
									{validFrom}
								</p>
							</div>
							<div className='RefuelEuRow row mx-0 px-3 py-2 border-top-1 palette--bc-neutral-3'>
								<p className='col-24 col-md-8 palette--c-neutral-5 m-0'>
									Valid to
								</p>
								<p className='col-24 col-md-16 palette--c-neutral-6 fw-bold m-0'>
									{validTo}
								</p>
							</div>
						</>
					)}
					{!isEligible && (
						<div className='RefuelEuRow row mx-0 px-3 py-2 border-top-1 palette--bc-neutral-3'>
							<p className='col-24 col-md-8 palette--c-neutral-5 m-0'>
								Status
							</p>
							<p className='col-24 col-md-16 palette--c-neutral-6 fw-bold m-0'>
								{status}
							</p>
						</div>
					)}
				</div>
			</div>
		);
	}

	private openModal() {
		const airportAid = this.props?.airport?.aid;
		const utmSource = isInQuery('utm_source') || '';

		this.props?.router?.navigate({
			pathname: `/airports/${airportAid}/refuel-eu`,
			search: utmSource,
		});
	}
}

export const RefuelEu: any = connect(mapStateProps, mapDispatchProps, null, {
	forwardRef: true,
})(connectNLP(RefuelEuComponent));
